import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./App.scss";
import reportWebVitals from "./reportWebVitals";

import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { CookiesProvider } from "react-cookie";
import AppRouter from "./routes/AppRouter";
import { PersistGate } from "redux-persist/integration/react";
import SpinnerEditeurPro from "./pages/FO/components/SpinnerEditeurPro";


import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './keycloak'
import { setAuthHeader } from "./utils/setAuthHeader";
import "react-toastify/dist/ReactToastify.css";
import { KeycloakInitOptions } from "keycloak-js";
import analytics from "./components/hooks/analytics";
import { ToastContainer } from "react-toastify";

const rootElement = document.getElementById("root") as HTMLElement;

const tokenLogger = (tokens: any) => {
  // Sauvegarde les tokens dans sessionStorage
  setAuthHeader(tokens.token);
};

const onEvent = (event: any, error: any) => {
 
  if (event === 'onReady') {
      analytics.sendEvent("login", {});
  }

  if (event === 'onAuthLogout') {
    //console.log("onAuthLogout")
    setAuthHeader(""); //suppression needed ? 
  }

  //à tester ??
  if (event === 'onTokenExpired') {
    //console.log("onTokenExpired")
    keycloak.updateToken(30).catch(() => keycloak.login());
  }
};


// Définir les options pour l'initialisation de Keycloak
const keycloakInitOptions: KeycloakInitOptions = {
 //onLoad: 'login-required',// Lance directeement keycloak
  onLoad: 'check-sso',// Vérifie la session silencieusement sans rediriger
  silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
  pkceMethod: 'S256',// Méthode sécurisée PKCE
  checkLoginIframe: false,//??
};

const RenderContent = (
  
    <ReactKeycloakProvider
    authClient={keycloak}
    onTokens={tokenLogger}
    onEvent={onEvent}
    initOptions={keycloakInitOptions}
    LoadingComponent={<SpinnerEditeurPro />}
    >
      <Provider store={store}>
        <PersistGate loading={<SpinnerEditeurPro />} persistor={persistor}>
        <React.StrictMode>
            <CookiesProvider>
              <AppRouter />
              <ToastContainer theme="colored" position="top-center" autoClose={4000} /> 
            </CookiesProvider>
          </React.StrictMode>
        </PersistGate>
      </Provider>
    </ReactKeycloakProvider>
);

// hydrateRoot uniquement sur "/" (seule route pré-rendue par react-snap à hydrater)
// Sur toute autre route, vider le DOM pour éviter le flash du contenu pré-rendu.
const isSnapRoute = window.location.pathname === "/";
if (rootElement.hasChildNodes() && isSnapRoute) {
  hydrateRoot(rootElement, RenderContent);
} else {
  rootElement.innerHTML = "";
  const root = createRoot(rootElement);
  root.render(RenderContent);
}




// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


